import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Eraser = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M16.3986 17.7844H6.04058L2.27401 14.0178C2.09863 13.8414 2.00019 13.6027 2.00019 13.3539C2.00019 13.1052 2.09863 12.8665 2.27401 12.6901L11.6904 3.27365C11.8669 3.09827 12.1055 2.99983 12.3543 2.99983C12.6031 2.99983 12.8417 3.09827 13.0181 3.27365L17.7264 7.98187C17.9017 8.15829 18.0002 8.39696 18.0002 8.64572C18.0002 8.89449 17.9017 9.13315 17.7264 9.30958L14.5002 12.5358M9.25158 17.7844L14.5002 12.5358M8.26 6.70409L14.5002 12.5358"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
})

export default Eraser
